// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/Fonts/SourceSansPro-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/Fonts/SourceSansPro-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/Fonts/SourceSansPro-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/Fonts/SourceSansPro-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/Fonts/SourceSansPro-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SourceSansPro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 400; /* Normal */
  font-style: normal;
}

@font-face {
  font-family: "SourceSansPro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 700; /* Bold */
  font-style: normal;
}

@font-face {
  font-family: "SourceSansPro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 900; /* Extra Bold */
  font-style: normal;
}

@font-face {
  font-family: "SourceSansPro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: 300; /* Light */
  font-style: normal;
}
@font-face {
  font-family: "SourceSansPro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 500;
  font-style: normal;
}

/* Apply globally */
body {
  font-family: "SourceSansPro", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "SourceSansPro", sans-serif;
  color: #4d4d4d;
}
label {
  font-family: "SourceSansPro", sans-serif;
  color: #4d4d4d;
  font-weight: 400;
}
.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}
.f-12 {
  font-size: 12px;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
/* Add this to your CSS file or inside a <style> tag */
.card-containerStyle {
  position: relative;
  width: auto; /* Adjust based on your layout */
}

.card-containerStyle p {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: max-height 0.3s ease, opacity 0.3s ease;
  max-height: 1.2em; /* Adjust based on the default text height */
  opacity: 1;
}

.card-containerStyle:hover p {
  max-height: 3em; /* Adjust based on the full text height */
  opacity: 1;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
.truncate-multiline-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
.truncate-multiline {
  overflow: hidden; /* Hide overflow */
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limit to 2 lines */
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
.truncate-multiline-3 {
  overflow: hidden; /* Hide overflow */
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Limit to 2 lines */
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}
.App-link {
  color: #61dafb;
}
.css-13cymwt-control {
  border: 1px solid #ebeaec !important;
  border-color: #ebeaec;
}
@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.blue_btn {
  background: linear-gradient(to right, #1995d2, #0d7ab8);
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  height: 40px;
  line-height: 20px;
  list-style: none;
  outline: none;
  padding: 10px 18px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: color 200ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  text-transform: uppercase;
  letter-spacing: 1.5;
  letter-spacing: 0.2px;
}

.blue_btn_rounded{
  background-color: #1995d2;
  border-radius: 100%;
  border-style: none;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  height: 40px;
  width: 40px;
  list-style: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 10px 18px; */
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: color 200ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  text-transform: uppercase;
  letter-spacing: 1.5;
  letter-spacing: 0.2px;

}
.blue_btn_rounded:hover,
.blue_btn_rounded:focus{
   background-color: #089eee;
}

.blue_btn:hover,
.blue_btn:focus {
  background-color: #089eee;
}

.closed_btn {
  background-color: #cf5864;
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  height: 40px;
  line-height: 20px;
  list-style: none;
  outline: none;
  padding: 10px 18px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: color 200ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  text-transform: uppercase;
  letter-spacing: 1.5;
  letter-spacing: 0.2px;
}

.closed_btn:hover,
.closed_btn:focus {
  background-color: #eb5f6d;
}

.white_btn {
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #1995d2;
  box-sizing: border-box;
  color: #1995d2;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  height: 40px;
  line-height: 20px;
  list-style: none;
  outline: none;
  padding: 10px 18px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: color 200ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  text-transform: uppercase;
  letter-spacing: 1.5;
  letter-spacing: 0.2px;
}

.white_btn:hover,
.white_btn:focus {
  color: #089eee;
  border: 1px solid #089eee;
}

.gray_btn {
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  color: #4d4d4d;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  list-style: none;
  padding: 10px 12px;
  text-align: center;
  transition: all 200ms;
  vertical-align: baseline;
  white-space: nowrap;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}
.gray_btn:hover {
  background-color: #e6e6e6;
}
.greyfill_btn {
  background-color: #e6e6e6;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  color: #4d4d4d;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  list-style: none;
  padding: 10px 12px;
  text-align: center;
  transition: all 200ms;
  vertical-align: baseline;
  white-space: nowrap;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}
.greyfill_btn:hover {
  background-color: #fff;
}

.lightblue_btn {
  /* font-size: .8rem; */
  /* padding: 6px 29px; */
  /* border-radius: 5px; */
  /* font-size: .7rem;  */
  font-size: 12px;
  padding: 5px 23px;
  border-radius: 5px;
  transition: all 0.15s ease;
  background-color: #1995d240 !important;
  color: #1995d2 !important;
  border: 1px solid #1995d2;
  text-align: center;
  color: #fff;
  line-height: 24px;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}
.lightblue_btn:hover {
  background-color: #1995d2 !important;
  color: #fff !important;
  border: 1px solid #1995d2 !important;
  font-weight: 400;
  text-decoration: none;
  transition: all 0.3s;
}

.lightgrey_btn {
  font-size: 12px;
  padding: 5px 23px;
  border-radius: 5px;
  transition: all 0.15s ease;
  background-color: #cac9c9ce !important;
  color: #4d4d4d !important;
  border: 1px solid #4d4d4d;
  text-align: center;
  color: #fff;
  line-height: 24px;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}

.lightgrey_btn:hover {
  background-color: #4d4d4d !important;
  color: #fff !important;
  border: 1px solid #4d4d4d !important;
  font-weight: 400;
  text-decoration: none;
  transition: all 0.3s;
}
.unfilled_btn {
  font-size: 12px;
  padding: 5px 23px;
  border-radius: 5px;
  transition: all 0.15s ease;
  background-color: #fff !important;
  color: #1995d2 !important;
  border: 1px solid #cac9c9ce;
  text-align: center;
  color: #fff;
  line-height: 24px;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}

.unfilled_btn:hover {
  background-color: #1995d2 !important;
  color: #fff !important;
  border: 1px solid #1995d2 !important;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s;
  font-size: 12px;
}

.blue_submit_btn {
  font-size: 12px;
  padding: 5px 23px;
  border-radius: 5px;
  transition: all 0.15s ease;
  background-color: #1995d2 !important;
  border: 1px solid #1995d2;
  text-align: center;
  color: #fff;
  line-height: 24px;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}

/* tags css */
.status-inactive {
  border-radius: 5px;
  font-weight: bold;
  font-size: 11.5px;
  color: #ff4c4c;
  background-color: #ffffff;
  border: none;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  width: 5rem;
  height: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-active {
  border-radius: 5px;
  font-weight: bold;
  font-size: 11.5px;
  color: #00974f;
  background-color: #ffffff;
  border: none;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  width: 5rem;
  height: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.d-shadow {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

.defaultColorBorder {
  border: 1px solid #4d4d4d50;
}
.defaultColorBorderfull {
  border: 1px solid #4d4d4d;
}
.border {
  border: 1px solid #ebeaec !important;
}
.defaultBordeBlue {
  border: 1px solid #1995d2 !important;
}
.defaultBordeBlue-t {
  border-top: 1px solid #1995d2 !important;
}
.defaultBordeBlue-t3 {
  border-top: 3px solid #1995d2 !important;
}

.defaultbgColor10 {
  background: #a0a0a010;
}
.defaultbgColor50 {
  background: #a0a0a050;
}
.grayColor {
  color: #9b9b9b;
}
.lightbgcolor {
  background: #e9e9e8;
}
p {
  color: #4d4d4d;
}
.defaultTextBlue {
  color: #1995d2;
}
.defaultBlueBorder-b {
  border-bottom: 2px solid #1995d2;
}
.defaultBlueBorder {
  border: 2px solid #1995d2;
}
.defaultBlueBg {
  background: #1995d2;
}
.defaultBlueBg10 {
  background: #1995d210;
}
.defaultBlackColor {
  color: #4d4d4d;
}
.primaryborder {
  border: 1px solid #9b9b9b;
}
.defaultgreyBgkColor {
  background: #4d4d4d;
}
@keyframes slideIn {
  0% {
    transform: translateX(100%);
    /* border-width: 0; */
  }
  100% {
    transform: translateX(0);
    /* border-width: 4px; */
  }
}

@keyframes slideOut {
  0% {
    transform: translateX(0);
    /* border-width: 4px; */
  }
  100% {
    transform: translateX(100%);
    /* border-width: 0; */
  }
}

.toast-enter {
  animation: slideIn 0.5s ease-out;
}

.toast-exit {
  animation: slideOut 0.5s ease-in;
}
.active {
  background-color: #4d4d4d;
  /* box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 65%); */
}
.loginactive {
  background-color: #efefef;
}
.css-honxw6,
.css-1097eso {
  color: #4d4d4d;
}
html,
body,
#root {
  height: 100%;
  scroll-behavior: smooth;
}
.header {
  color: #cdcdcd;
}
.react-flow__node-mindmap {
  background: white;
  border-radius: 2px;
  border: none;
  padding: 6px 10px;
  font-weight: 700;
  font-size: 10px;
}
.react-flow__handle.target {
  top: 50%;
  pointer-events: none;
  opacity: 0;
}
.react-flow__handle.source {
  top: 0;
  left: 0;
  transform: none;
  background: #1995d220;
  border: 1px solid #1995d2;
  height: 100%;
  width: 100%;
  border-radius: 2px;
}
.react-flow .react-flow__connectionline {
  z-index: 0;
}
.inputWrapper {
  display: flex;
  height: 20px;
  z-index: 1;
  position: relative;
  pointer-events: none;
}
.dragHandle {
  background: transparent;
  width: 14px;
  height: 100%;
  margin-right: 4px;
  display: flex;
  align-items: center;
  pointer-events: all;
}
.input {
  border: none;
  padding: 0 2px;
  border-radius: 1px;
  font-weight: 700;
  background: transparent;
  height: 100%;
  pointer-events: none;
}
.input:focus {
  border: none;
  outline: none;
  background: rgba(255, 255, 255, 0.25);
  pointer-events: all;
}
.react-flow__attribution a {
  color: #fff !important;
}

/* Keyframes for animations */
@keyframes animationLeftRight {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(1000px);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes animationRightLeft {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-1000px);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes gradientTransition {
  0% {
    background: linear-gradient(
      to right,
      rgba(211, 211, 211, 0.3),
      rgba(211, 211, 211, 0.3)
    ); /* Gray with 30% opacity */
  }
  100% {
    background: linear-gradient(to right, #ffffff, #ffffff); /* White color */
  }
}

/* Animation class */
.bg-gradient-transition {
  animation: gradientTransition 3s ease-in-out forwards; /* Adjust duration and timing function as needed */
}
/* Animation classes */
.animationLeftRight {
  animation: animationLeftRight 2s ease-in-out 1;
}

.animationRightLeft {
  animation: animationRightLeft 2s ease-in-out 1;
}

/* Time-based Transition Durations */
.tans3s {
  animation-duration: 3s;
}

.tans4s {
  animation-duration: 4s;
}


@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Checkmark animation */
@keyframes checkmark {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

/* Loader spinner style */
.loader {
  animation: spinner 1s linear infinite;
}

/* Checkmark style */
.checkmark {
  animation: checkmark 0.5s ease-out;
}

.loaderspinner {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.card-artical-image {
  object-fit: cover; /* Cover ensures image scales correctly without distortion */
  transition: transform 0.3s ease;
}

.boardDatepicker .react-datepicker-wrapper {
  width: 100%;
}

.tilt-effect {
  transition: transform 0.5s ease-in-out;
}

.tilt-effect:hover {
  transform: rotateY(12deg) rotateX(10deg);
}
/* styles.css */
@keyframes slideInFromLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slideOutToRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

.slide-in {
  animation: slideInFromLeft 300ms ease-out forwards;
}

.slide-out {
  animation: slideOutToRight 300ms ease-in forwards;
}

.setting .react-datepicker-wrapper {
  width: 100%;
}
.workfustionbg {
  background-color: #f3f4f6;
}

.hover-animate {
  transition: transform 0.3s ease;
  cursor: pointer;
}

.hover-animate:hover {
  transform: translateY(-5px); /* Move the element up by 5px */
  cursor: pointer;
}

.gen-info {
  transition: opacity 0.5s, transform 0.8s;
}

.gen-title {
  transition: opacity 0.8s, transform 0.4s;
  font-size: 3rem;
}

.gen-description {
  transition: opacity 0.49, transform 0.4s;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-up {
  animation: fadeInUp 2.9s ease forwards;
  opacity: 1;
}

@keyframes glow {
  0% {
    text-shadow: 0 0 5px rgba(255, 255, 255, 0.5),
      0 0 10px rgba(255, 255, 255, 0.5);
    color: #1f2937; /* Dark text color */
  }
  50% {
    text-shadow: 0 0 20px rgba(30, 175, 255, 1), 0 0 30px rgba(30, 175, 255, 1);
    color: #1995d2; /* Bright color */
  }
  100% {
    text-shadow: 0 0 5px rgba(255, 255, 255, 0.5),
      0 0 10px rgba(255, 255, 255, 0.5);
    color: #1f2937;
  }
}

.glowing-text {
  display: inline-block;
  animation: glow 1.5s infinite;
}

.css-dip3t8 {
  background-color: white !important;
  padding: 10px;
}
.ps-menu-button {
  /* padding-left: 10px !important; */
  height: 40px !important;
  margin-left: -10px !important;
}
.css-1tqrhto > .ps-menu-button {
  padding-left: 40px !important;
}
.css-wx7wi4{
  margin-right: 5px !important; 
}

.active-class-menu{
  background-color: #E9E8E8 !important; 
  border-radius: 10px;
  
}
.active-class {
  background-color: #E9E8E8; /* or your desired active color */
  font-weight: 700;
  border-radius: 10px;
}

.active-class:hover {
  background-color: #E9E8E8; /* or your desired active color */
}

.active-class.ps-menu-label {
  color: #4d4d4d !important; /* or your desired text color */
}
.active-class.ps-menu-icon {
  color: #4d4d4d !important; /* or your desired text color */
}
.ps-menu-button:hover {
  font-weight: 700;
  transition: all 0.2s ease-in-out;
  border-radius: 40px;
  background-color: transparent !important;
}
.css-1tqrhto > .ps-menu-button:hover {
  background-color: transparent !important;
}
.css-12w9als {
  color: #4d4d4d;
}

.css-wx7wi4 {
  color: #4d4d4d;
}

.typing-effect {
  overflow: hidden; /* Ensures text stays within container */
  white-space: nowrap; /* Keeps text on a single line */
  animation: typing 5s steps(10) 1s infinite normal,
    blink 0.75s step-end infinite;
}

@keyframes typing {
  0% {
    width: 0;
  }
  50% {
    width: 100%;
  }
  100% {
    width: 0;
  }
}

.slick-slide {
  margin-right: 2rem;
}
.testimonialssection .slick-slide {
  margin-right: 0rem !important;
}

.slick-dots {
  bottom: 12px !important;
}

.slick-card {
  display: flex !important;
  justify-content: center;
  align-items: center;
}

@keyframes glowing-border {
  0% {
    border-color: #1995d2;
    box-shadow: 0 0 10px #1995d2;
  }
  50% {
    border-color: #4bcffa;
    box-shadow: 0 0 20px #4bcffa;
  }
  100% {
    border-color: #1995d2;
    box-shadow: 0 0 10px #1995d2;
  }
}

.glowing-border {
  border: 2px solid transparent;
  animation: glowing-border 2s infinite;
  border-radius: 8px; /* Match your modal's border-radius */
  padding: 10px; /* Adjust if needed */
}

.article-content * {
  font-size: inherit;
}

.truncate-container {
  display: -webkit-box; /* Use webkit box model */
  -webkit-box-orient: vertical; /* Set orientation to vertical */
  -webkit-line-clamp: 2; /* Limit to 2 lines */
  overflow: hidden; /* Hide overflow */
  text-overflow: ellipsis; /* Add ellipsis when text overflows */
  white-space: normal; /* Allow wrapping */
}

.p0-initiate {
  background-color: transparent;
  color: #ff4545;
  border: 1.5px solid #ff4545; /* Red border */
  border-radius: 16px; /* Rounded corners */
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  height: fit-content;
  padding: 5px;
}

.p0-initiate:hover {
  box-shadow: 0 4px 8px rgba(255, 0, 0, 0.3); /* Red shadow on hover */
  transform: translateY(-2px); /* Slight upward movement on hover */
}

.red_btn {
  background-color: #fff;
  border-radius: 8px;
  color: #ff4c4c;
  border: 1px solid #ff4c4c;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  height: 40px;
  line-height: 20px;
  list-style: none;
  outline: none;
  padding: 10px 18px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: color 200ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  text-transform: uppercase;
  letter-spacing: 1.5;
  letter-spacing: 0.2px;
}

.red_btn:hover,
.red_btn:focus {
  color: #ff4c4c;
  border: 1px solid #ff4c4c;
}

.slick-track {
  transform: translate3d(-488px, 0px, 0px);
}

.Assessment_btn {
  font-size: 12px;
  padding: 5px 23px;
  border-radius: 5px;
  transition: all 0.15s ease;
  border: 1px solid none;
  text-align: center;
  color: #fff;
  line-height: 24px;
  cursor: pointer;
}

.recommend-article {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* In your CSS file or Tailwind custom styles */
.article-content iframe {
  width: 560px;
  height: 315px;
  margin: 0 auto;
  display: block;
  max-width: 100%;
  height: auto;
}
.PhoneInputInput {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

select:not(.rdt_Pagination select) {
  appearance: none;
  padding: 0.625rem ;
  border: 1px solid #ebeaec;
  background-color: #f9fafb;
  /* font-size: 12px; */

  background-image: url("https://www.svgrepo.com/show/304510/arrow-bottom.svg"); /* Right arrow icon */
  background-position: right 10px center;
  background-repeat: no-repeat;
  background-size: 20px 20px;
}

.ps-submenu-expand-icon{
  margin-bottom: 7px;
}
.profileSetting .PhoneInputInput {
  background-color: #f9fafb !important;
}

@keyframes ribbonPop {
  0% {
    opacity: 0;
    transform: translateY(-10px) rotate(45deg) scale(0.9);
  }
  50% {
    opacity: 0.5;
    transform: translateY(0px) rotate(45deg) scale(1.05);
  }
  100% {
    opacity: 1;
    transform: translateY(0px) rotate(45deg) scale(1);
  }
}

.animate-ribbon {
  animation: ribbonPop 0.6s ease-out;
}

.feature-title {
  font-size: 24px;
}

.feature-subtitle {
  font-size: 18px;
}

.card-title {
  font-size: 18px;
}

.card-subtitle {
  font-size: 14px;
  font-weight: 400;
  margin-top: 5px;
}

.card-icon-background{
  background-color: #f3f4f6 ;
}

.card-icon {
  color: #1995d2;
  font-size: 18px;
}

.card-delete-icon{
  color: #f75d65;
  font-size: 18px;
}

.table-icon {
  font-size: 19px;
}

.table-icon:hover {
  color: #1995d2;
}

.table-delete-icon{
  font-size: 19px;
}

.table-delete-icon:hover {
  color: #f75d65;
}
.content-from-backend ul {
  list-style: disc inside; /* Changed to 'inside' */
  margin: 0;
  padding: 0; /* You might still want a slight padding-left on the ul here for overall indentation */
  margin-bottom: 0.5em;
}
.content-from-backend ol {
  list-style-type: decimal; /* Ensures numerical markers (1, 2, 3...) */
  margin: 0; /* Remove default margin */
  padding-left: 1.2em;
  margin-bottom: 0.5em; /* Space after the list */
}
/* In your CSS file (e.g., TableStylePanel.css or a global CSS file) */
.hide-scrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;     /* Firefox */
}

/* For Webkit browsers (Chrome, Safari) */
.hide-scrollbar::-webkit-scrollbar {
  display: none;             /* Hide scrollbar */
}

.content-from-backend li {
  display: list-item; /* This ensures it behaves as a list item */
  margin-bottom: 0.4em; /* Space between list items */
  line-height: 1.5;
  /* Importantly, remove any extra padding/margin that might be here */
  padding: 0;
  margin: 0;
}

/* Add a rule to remove default margin from paragraphs *inside* list items */
.content-from-backend li p {
  margin: 0; /* This is CRUCIAL to prevent the <p> from forcing a new line */
  display: inline; /* Treat the paragraph as inline content within the list item */
  /* Or if you need to keep block behavior but not force newline: */
  /* display: inline-block; */
}

.page-break {
  page-break-after: always;
  break-after: page;
}

.chart-card, .chart-card * {
  overflow: visible !important;
}



@media (max-width: 767px) {
  .margin-mobile {
    margin-top: 8rem; /* Apply 14rem margin-top on mobile screens */
  }
  .margin-mobile-view {
    margin-top: 20rem; /* Apply 14rem margin-top on mobile screens */
  }
}



@keyframes rotateXIcon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

.rotate-x-icon {
  animation: rotateXIcon 0.5s ease-out forwards;
}

/* Wavy scaling animation */
    .wave-ring {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 9999px;
      background-color: rgba(34, 87, 222, 0.3); 
      animation: ripple 1.8s ease-out infinite;
      z-index: -1;
    }

    @keyframes ripple {
      0% {
        transform: scale(1);
        opacity: 0.7;
      }
      100% {
        transform: scale(2);
        opacity: 0;
      }
    }

.quill-custom-height .ql-editor {
  height: 150px; 
  overflow-y: auto;
} 
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,+DAAuE;EACvE,gBAAgB,EAAE,WAAW;EAC7B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAAoE;EACpE,gBAAgB,EAAE,SAAS;EAC3B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAAqE;EACrE,gBAAgB,EAAE,eAAe;EACjC,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAA0E;EAC1E,gBAAgB,EAAE,UAAU;EAC5B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,+DAAwE;EACxE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,wCAAwC;AAC1C;;AAEA;;;;;;EAME,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,wCAAwC;EACxC,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;AACA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,WAAW,EAAE,gCAAgC;AAC/C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;EACnD,iBAAiB,EAAE,4CAA4C;EAC/D,UAAU;AACZ;;AAEA;EACE,eAAe,EAAE,yCAAyC;EAC1D,UAAU;EACV,gBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;AACzB;AAEE;EAAA,gBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B;AAJsB;AAOtB;EAAA,gBAAsB,EAAE,kBAAkB;EAC1C,oBAAoB;EACpB,qBAAqB,EAAE,qBAAqB;EAC5C,4BAA4B;EAC5B;AAJsB;AAOtB;EAAA,gBAAsB,EAAE,kBAAkB;EAC1C,oBAAoB;EACpB,qBAAqB,EAAE,qBAAqB;EAC5C,4BAA4B;EAC5B;AAJsB;AAMxB;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,uDAAuD;EACvD,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;;AAEvB;AACA;;GAEG,yBAAyB;AAC5B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,iCAAiC;EACjC,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,oCAAoC;EAEpC,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,2BAA2B;IAC3B,qBAAqB;EACvB;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,2BAA2B;IAC3B,qBAAqB;EACvB;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,oFAAoF;AACtF;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;;;EAGE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,QAAQ;EACR,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,MAAM;EACN,OAAO;EACP,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE;;;;KAIC,EAAE,0BAA0B;EAC/B;EACA;IACE,uDAAuD,EAAE,gBAAgB;EAC3E;AACF;;AAEA,oBAAoB;AACpB;EACE,qDAAqD,EAAE,kDAAkD;AAC3G;AACA,sBAAsB;AACtB;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,yBAAyB;AACzB;EACE,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,6BAA6B,EAAE,SAAS;EACxC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB,EAAE,4DAA4D;EAC/E,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;AACA,eAAe;AACf;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,2BAA2B,EAAE,+BAA+B;EAC5D,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE;IACE;uCACmC;IACnC,cAAc,EAAE,oBAAoB;EACtC;EACA;IACE,2EAA2E;IAC3E,cAAc,EAAE,iBAAiB;EACnC;EACA;IACE;uCACmC;IACnC,cAAc;EAChB;AACF;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,aAAa;AACf;AACA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;;AAErB;AACA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;AAC9D;;AAEA;EACE,yBAAyB,EAAE,+BAA+B;AAC5D;AACA;EACE,yBAAyB,EAAE,+BAA+B;AAC5D;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB,EAAE,wCAAwC;EAC1D,mBAAmB,EAAE,gCAAgC;EACrD;iCAC+B;AACjC;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,QAAQ;EACV;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;IACrB,4BAA4B;EAC9B;EACA;IACE,qBAAqB;IACrB,4BAA4B;EAC9B;EACA;IACE,qBAAqB;IACrB,4BAA4B;EAC9B;AACF;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB,EAAE,qCAAqC;EACzD,aAAa,EAAE,qBAAqB;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB,EAAE,yBAAyB;EAC/C,4BAA4B,EAAE,gCAAgC;EAC9D,qBAAqB,EAAE,qBAAqB;EAC5C,gBAAgB,EAAE,kBAAkB;EACpC,uBAAuB,EAAE,qCAAqC;EAC9D,mBAAmB,EAAE,mBAAmB;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,2BAA2B,EAAE,eAAe;EAC5C,mBAAmB,EAAE,oBAAoB;EACzC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0CAA0C,EAAE,wBAAwB;EACpE,2BAA2B,EAAE,oCAAoC;AACnE;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAE1B,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,+CAA+C;AAC/C;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;;EAErB,6EAA6E,EAAE,qBAAqB;EACpG,sCAAsC;EACtC,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,qDAAqD;EACvD;EACA;IACE,YAAY;IACZ,oDAAoD;EACtD;EACA;IACE,UAAU;IACV,iDAAiD;EACnD;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB,EAAE,wBAAwB;EACjD,SAAS;EACT,UAAU,EAAE,sFAAsF;EAClG,oBAAoB;AACtB;AACA;EACE,wBAAwB,EAAE,2CAA2C;EACrE,SAAS,EAAE,0BAA0B;EACrC,mBAAmB;EACnB,oBAAoB,EAAE,yBAAyB;AACjD;AACA,sEAAsE;AACtE;EACE,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,MAAM,YAAY;AACzC;;AAEA,yCAAyC;AACzC;EACE,aAAa,cAAc,mBAAmB;AAChD;;AAEA;EACE,kBAAkB,EAAE,2CAA2C;EAC/D,oBAAoB,EAAE,6BAA6B;EACnD,gBAAgB;EAChB,oEAAoE;EACpE,UAAU;EACV,SAAS;AACX;;AAEA,4EAA4E;AAC5E;EACE,SAAS,EAAE,+DAA+D;EAC1E,eAAe,EAAE,+DAA+D;EAChF,iEAAiE;EACjE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;;;AAIA;EACE;IACE,gBAAgB,EAAE,6CAA6C;EACjE;EAIA;IACE,iBAAiB,EAAE,6CAA6C;EAClE;AALF;;;;AAUA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,2BAA2B;IACvB;MACE,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,qBAAqB;MACrB,wCAAwC;MACxC,wCAAwC;MACxC,WAAW;IACb;;IAEA;MACE;QACE,mBAAmB;QACnB,YAAY;MACd;MACA;QACE,mBAAmB;QACnB,UAAU;MACZ;IACF;;AAEJ;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: \"SourceSansPro\";\n  src: url(\"./assets/Fonts/SourceSansPro-Regular.ttf\") format(\"truetype\");\n  font-weight: 400; /* Normal */\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"SourceSansPro\";\n  src: url(\"./assets/Fonts/SourceSansPro-Bold.ttf\") format(\"truetype\");\n  font-weight: 700; /* Bold */\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"SourceSansPro\";\n  src: url(\"./assets/Fonts/SourceSansPro-Black.ttf\") format(\"truetype\");\n  font-weight: 900; /* Extra Bold */\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"SourceSansPro\";\n  src: url(\"./assets/Fonts/SourceSansPro-ExtraLight.ttf\") format(\"truetype\");\n  font-weight: 300; /* Light */\n  font-style: normal;\n}\n@font-face {\n  font-family: \"SourceSansPro\";\n  src: url(\"./assets/Fonts/SourceSansPro-Semibold.ttf\") format(\"truetype\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n/* Apply globally */\nbody {\n  font-family: \"SourceSansPro\", sans-serif;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"SourceSansPro\", sans-serif;\n  color: #4d4d4d;\n}\nlabel {\n  font-family: \"SourceSansPro\", sans-serif;\n  color: #4d4d4d;\n  font-weight: 400;\n}\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n.f-12 {\n  font-size: 12px;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n/* Add this to your CSS file or inside a <style> tag */\n.card-containerStyle {\n  position: relative;\n  width: auto; /* Adjust based on your layout */\n}\n\n.card-containerStyle p {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: max-height 0.3s ease, opacity 0.3s ease;\n  max-height: 1.2em; /* Adjust based on the default text height */\n  opacity: 1;\n}\n\n.card-containerStyle:hover p {\n  max-height: 3em; /* Adjust based on the full text height */\n  opacity: 1;\n  @apply overflow-hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n}\n.truncate-multiline-1 {\n  @apply overflow-hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n}\n.truncate-multiline {\n  @apply overflow-hidden; /* Hide overflow */\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* Limit to 2 lines */\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n}\n.truncate-multiline-3 {\n  @apply overflow-hidden; /* Hide overflow */\n  display: -webkit-box;\n  -webkit-line-clamp: 3; /* Limit to 2 lines */\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n}\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n.App-link {\n  color: #61dafb;\n}\n.css-13cymwt-control {\n  border: 1px solid #ebeaec !important;\n  border-color: #ebeaec;\n}\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.blue_btn {\n  background: linear-gradient(to right, #1995d2, #0d7ab8);\n  border-radius: 8px;\n  border-style: none;\n  box-sizing: border-box;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  height: 40px;\n  line-height: 20px;\n  list-style: none;\n  outline: none;\n  padding: 10px 18px;\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  transition: color 200ms;\n  vertical-align: baseline;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  text-transform: uppercase;\n  letter-spacing: 1.5;\n  letter-spacing: 0.2px;\n}\n\n.blue_btn_rounded{\n  background-color: #1995d2;\n  border-radius: 100%;\n  border-style: none;\n  box-sizing: border-box;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  height: 40px;\n  width: 40px;\n  list-style: none;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* padding: 10px 18px; */\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  transition: color 200ms;\n  vertical-align: baseline;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  text-transform: uppercase;\n  letter-spacing: 1.5;\n  letter-spacing: 0.2px;\n\n}\n.blue_btn_rounded:hover,\n.blue_btn_rounded:focus{\n   background-color: #089eee;\n}\n\n.blue_btn:hover,\n.blue_btn:focus {\n  background-color: #089eee;\n}\n\n.closed_btn {\n  background-color: #cf5864;\n  border-radius: 8px;\n  border-style: none;\n  box-sizing: border-box;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  height: 40px;\n  line-height: 20px;\n  list-style: none;\n  outline: none;\n  padding: 10px 18px;\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  transition: color 200ms;\n  vertical-align: baseline;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  text-transform: uppercase;\n  letter-spacing: 1.5;\n  letter-spacing: 0.2px;\n}\n\n.closed_btn:hover,\n.closed_btn:focus {\n  background-color: #eb5f6d;\n}\n\n.white_btn {\n  background-color: #fff;\n  border-radius: 8px;\n  border: 1px solid #1995d2;\n  box-sizing: border-box;\n  color: #1995d2;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  height: 40px;\n  line-height: 20px;\n  list-style: none;\n  outline: none;\n  padding: 10px 18px;\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  transition: color 200ms;\n  vertical-align: baseline;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  text-transform: uppercase;\n  letter-spacing: 1.5;\n  letter-spacing: 0.2px;\n}\n\n.white_btn:hover,\n.white_btn:focus {\n  color: #089eee;\n  border: 1px solid #089eee;\n}\n\n.gray_btn {\n  background-color: #fff;\n  border-radius: 8px;\n  border: 1px solid #e5e5e5;\n  color: #4d4d4d;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 20px;\n  list-style: none;\n  padding: 10px 12px;\n  text-align: center;\n  transition: all 200ms;\n  vertical-align: baseline;\n  white-space: nowrap;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  text-transform: uppercase;\n  letter-spacing: 0.2px;\n}\n.gray_btn:hover {\n  background-color: #e6e6e6;\n}\n.greyfill_btn {\n  background-color: #e6e6e6;\n  border-radius: 8px;\n  border: 1px solid #e5e5e5;\n  color: #4d4d4d;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 20px;\n  list-style: none;\n  padding: 10px 12px;\n  text-align: center;\n  transition: all 200ms;\n  vertical-align: baseline;\n  white-space: nowrap;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  text-transform: uppercase;\n  letter-spacing: 0.2px;\n}\n.greyfill_btn:hover {\n  background-color: #fff;\n}\n\n.lightblue_btn {\n  /* font-size: .8rem; */\n  /* padding: 6px 29px; */\n  /* border-radius: 5px; */\n  /* font-size: .7rem;  */\n  font-size: 12px;\n  padding: 5px 23px;\n  border-radius: 5px;\n  transition: all 0.15s ease;\n  background-color: #1995d240 !important;\n  color: #1995d2 !important;\n  border: 1px solid #1995d2;\n  text-align: center;\n  color: #fff;\n  line-height: 24px;\n  text-transform: uppercase;\n  letter-spacing: 0.2px;\n}\n.lightblue_btn:hover {\n  background-color: #1995d2 !important;\n  color: #fff !important;\n  border: 1px solid #1995d2 !important;\n  font-weight: 400;\n  text-decoration: none;\n  transition: all 0.3s;\n}\n\n.lightgrey_btn {\n  font-size: 12px;\n  padding: 5px 23px;\n  border-radius: 5px;\n  transition: all 0.15s ease;\n  background-color: #cac9c9ce !important;\n  color: #4d4d4d !important;\n  border: 1px solid #4d4d4d;\n  text-align: center;\n  color: #fff;\n  line-height: 24px;\n  text-transform: uppercase;\n  letter-spacing: 0.2px;\n}\n\n.lightgrey_btn:hover {\n  background-color: #4d4d4d !important;\n  color: #fff !important;\n  border: 1px solid #4d4d4d !important;\n  font-weight: 400;\n  text-decoration: none;\n  transition: all 0.3s;\n}\n.unfilled_btn {\n  font-size: 12px;\n  padding: 5px 23px;\n  border-radius: 5px;\n  transition: all 0.15s ease;\n  background-color: #fff !important;\n  color: #1995d2 !important;\n  border: 1px solid #cac9c9ce;\n  text-align: center;\n  color: #fff;\n  line-height: 24px;\n  text-transform: uppercase;\n  letter-spacing: 0.2px;\n}\n\n.unfilled_btn:hover {\n  background-color: #1995d2 !important;\n  color: #fff !important;\n  border: 1px solid #1995d2 !important;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s;\n  font-size: 12px;\n}\n\n.blue_submit_btn {\n  font-size: 12px;\n  padding: 5px 23px;\n  border-radius: 5px;\n  transition: all 0.15s ease;\n  background-color: #1995d2 !important;\n  color: #fff !important;\n  border: 1px solid #1995d2;\n  text-align: center;\n  color: #fff;\n  line-height: 24px;\n  text-transform: uppercase;\n  letter-spacing: 0.2px;\n}\n\n/* tags css */\n.status-inactive {\n  border-radius: 5px;\n  font-weight: bold;\n  font-size: 11.5px;\n  color: #ff4c4c;\n  background-color: #ffffff;\n  border: none;\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);\n  width: 5rem;\n  height: 21px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.status-active {\n  border-radius: 5px;\n  font-weight: bold;\n  font-size: 11.5px;\n  color: #00974f;\n  background-color: #ffffff;\n  border: none;\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);\n  width: 5rem;\n  height: 21px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.d-shadow {\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n}\n\n.defaultColorBorder {\n  border: 1px solid #4d4d4d50;\n}\n.defaultColorBorderfull {\n  border: 1px solid #4d4d4d;\n}\n.border {\n  border: 1px solid #ebeaec !important;\n}\n.defaultBordeBlue {\n  border: 1px solid #1995d2 !important;\n}\n.defaultBordeBlue-t {\n  border-top: 1px solid #1995d2 !important;\n}\n.defaultBordeBlue-t3 {\n  border-top: 3px solid #1995d2 !important;\n}\n\n.defaultbgColor10 {\n  background: #a0a0a010;\n}\n.defaultbgColor50 {\n  background: #a0a0a050;\n}\n.grayColor {\n  color: #9b9b9b;\n}\n.lightbgcolor {\n  background: #e9e9e8;\n}\np {\n  color: #4d4d4d;\n}\n.defaultTextBlue {\n  color: #1995d2;\n}\n.defaultBlueBorder-b {\n  border-bottom: 2px solid #1995d2;\n}\n.defaultBlueBorder {\n  border: 2px solid #1995d2;\n}\n.defaultBlueBg {\n  background: #1995d2;\n}\n.defaultBlueBg10 {\n  background: #1995d210;\n}\n.defaultBlackColor {\n  color: #4d4d4d;\n}\n.primaryborder {\n  border: 1px solid #9b9b9b;\n}\n.defaultgreyBgkColor {\n  background: #4d4d4d;\n}\n@keyframes slideIn {\n  0% {\n    transform: translateX(100%);\n    /* border-width: 0; */\n  }\n  100% {\n    transform: translateX(0);\n    /* border-width: 4px; */\n  }\n}\n\n@keyframes slideOut {\n  0% {\n    transform: translateX(0);\n    /* border-width: 4px; */\n  }\n  100% {\n    transform: translateX(100%);\n    /* border-width: 0; */\n  }\n}\n\n.toast-enter {\n  animation: slideIn 0.5s ease-out;\n}\n\n.toast-exit {\n  animation: slideOut 0.5s ease-in;\n}\n.active {\n  background-color: #4d4d4d;\n  /* box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 65%); */\n}\n.loginactive {\n  background-color: #efefef;\n}\n.css-honxw6,\n.css-1097eso {\n  color: #4d4d4d;\n}\nhtml,\nbody,\n#root {\n  height: 100%;\n  scroll-behavior: smooth;\n}\n.header {\n  color: #cdcdcd;\n}\n.react-flow__node-mindmap {\n  background: white;\n  border-radius: 2px;\n  border: none;\n  padding: 6px 10px;\n  font-weight: 700;\n  font-size: 10px;\n}\n.react-flow__handle.target {\n  top: 50%;\n  pointer-events: none;\n  opacity: 0;\n}\n.react-flow__handle.source {\n  top: 0;\n  left: 0;\n  transform: none;\n  background: #1995d220;\n  border: 1px solid #1995d2;\n  height: 100%;\n  width: 100%;\n  border-radius: 2px;\n}\n.react-flow .react-flow__connectionline {\n  z-index: 0;\n}\n.inputWrapper {\n  display: flex;\n  height: 20px;\n  z-index: 1;\n  position: relative;\n  pointer-events: none;\n}\n.dragHandle {\n  background: transparent;\n  width: 14px;\n  height: 100%;\n  margin-right: 4px;\n  display: flex;\n  align-items: center;\n  pointer-events: all;\n}\n.input {\n  border: none;\n  padding: 0 2px;\n  border-radius: 1px;\n  font-weight: 700;\n  background: transparent;\n  height: 100%;\n  pointer-events: none;\n}\n.input:focus {\n  border: none;\n  outline: none;\n  background: rgba(255, 255, 255, 0.25);\n  pointer-events: all;\n}\n.react-flow__attribution a {\n  color: #fff !important;\n}\n\n/* Keyframes for animations */\n@keyframes animationLeftRight {\n  0% {\n    transform: translateX(0);\n  }\n  50% {\n    transform: translateX(1000px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n@keyframes animationRightLeft {\n  0% {\n    transform: translateX(0);\n  }\n  50% {\n    transform: translateX(-1000px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n@keyframes gradientTransition {\n  0% {\n    background: linear-gradient(\n      to right,\n      rgba(211, 211, 211, 0.3),\n      rgba(211, 211, 211, 0.3)\n    ); /* Gray with 30% opacity */\n  }\n  100% {\n    background: linear-gradient(to right, #ffffff, #ffffff); /* White color */\n  }\n}\n\n/* Animation class */\n.bg-gradient-transition {\n  animation: gradientTransition 3s ease-in-out forwards; /* Adjust duration and timing function as needed */\n}\n/* Animation classes */\n.animationLeftRight {\n  animation: animationLeftRight 2s ease-in-out 1;\n}\n\n.animationRightLeft {\n  animation: animationRightLeft 2s ease-in-out 1;\n}\n\n/* Time-based Transition Durations */\n.tans3s {\n  animation-duration: 3s;\n}\n\n.tans4s {\n  animation-duration: 4s;\n}\n\n\n@keyframes spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Checkmark animation */\n@keyframes checkmark {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* Loader spinner style */\n.loader {\n  animation: spinner 1s linear infinite;\n}\n\n/* Checkmark style */\n.checkmark {\n  animation: checkmark 0.5s ease-out;\n}\n\n.loaderspinner {\n  border: 4px solid #f3f3f3; /* Light grey */\n  border-top: 4px solid #3498db; /* Blue */\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.card-artical-image {\n  object-fit: cover; /* Cover ensures image scales correctly without distortion */\n  transition: transform 0.3s ease;\n}\n\n.boardDatepicker .react-datepicker-wrapper {\n  width: 100%;\n}\n\n.tilt-effect {\n  transition: transform 0.5s ease-in-out;\n}\n\n.tilt-effect:hover {\n  transform: rotateY(12deg) rotateX(10deg);\n}\n/* styles.css */\n@keyframes slideInFromLeft {\n  from {\n    transform: translateX(-100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideOutToRight {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(100%);\n  }\n}\n\n.slide-in {\n  animation: slideInFromLeft 300ms ease-out forwards;\n}\n\n.slide-out {\n  animation: slideOutToRight 300ms ease-in forwards;\n}\n\n.setting .react-datepicker-wrapper {\n  width: 100%;\n}\n.workfustionbg {\n  background-color: #f3f4f6;\n}\n\n.hover-animate {\n  transition: transform 0.3s ease;\n  cursor: pointer;\n}\n\n.hover-animate:hover {\n  transform: translateY(-5px); /* Move the element up by 5px */\n  cursor: pointer;\n}\n\n.gen-info {\n  transition: opacity 0.5s, transform 0.8s;\n}\n\n.gen-title {\n  transition: opacity 0.8s, transform 0.4s;\n  font-size: 3rem;\n}\n\n.gen-description {\n  transition: opacity 0.49, transform 0.4s;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-fade-up {\n  animation: fadeInUp 2.9s ease forwards;\n  opacity: 1;\n}\n\n@keyframes glow {\n  0% {\n    text-shadow: 0 0 5px rgba(255, 255, 255, 0.5),\n      0 0 10px rgba(255, 255, 255, 0.5);\n    color: #1f2937; /* Dark text color */\n  }\n  50% {\n    text-shadow: 0 0 20px rgba(30, 175, 255, 1), 0 0 30px rgba(30, 175, 255, 1);\n    color: #1995d2; /* Bright color */\n  }\n  100% {\n    text-shadow: 0 0 5px rgba(255, 255, 255, 0.5),\n      0 0 10px rgba(255, 255, 255, 0.5);\n    color: #1f2937;\n  }\n}\n\n.glowing-text {\n  display: inline-block;\n  animation: glow 1.5s infinite;\n}\n\n.css-dip3t8 {\n  background-color: white !important;\n  padding: 10px;\n}\n.ps-menu-button {\n  /* padding-left: 10px !important; */\n  height: 40px !important;\n  margin-left: -10px !important;\n}\n.css-1tqrhto > .ps-menu-button {\n  padding-left: 40px !important;\n}\n.css-wx7wi4{\n  margin-right: 5px !important; \n}\n\n.active-class-menu{\n  background-color: #E9E8E8 !important; \n  border-radius: 10px;\n  \n}\n.active-class {\n  background-color: #E9E8E8; /* or your desired active color */\n  font-weight: 700;\n  border-radius: 10px;\n}\n\n.active-class:hover {\n  background-color: #E9E8E8; /* or your desired active color */\n}\n\n.active-class.ps-menu-label {\n  color: #4d4d4d !important; /* or your desired text color */\n}\n.active-class.ps-menu-icon {\n  color: #4d4d4d !important; /* or your desired text color */\n}\n.ps-menu-button:hover {\n  font-weight: 700;\n  transition: all 0.2s ease-in-out;\n  border-radius: 40px;\n  background-color: transparent !important;\n}\n.css-1tqrhto > .ps-menu-button:hover {\n  background-color: transparent !important;\n}\n.css-12w9als {\n  color: #4d4d4d;\n}\n\n.css-wx7wi4 {\n  color: #4d4d4d;\n}\n\n.typing-effect {\n  overflow: hidden; /* Ensures text stays within container */\n  white-space: nowrap; /* Keeps text on a single line */\n  animation: typing 5s steps(10) 1s infinite normal,\n    blink 0.75s step-end infinite;\n}\n\n@keyframes typing {\n  0% {\n    width: 0;\n  }\n  50% {\n    width: 100%;\n  }\n  100% {\n    width: 0;\n  }\n}\n\n.slick-slide {\n  margin-right: 2rem;\n}\n.testimonialssection .slick-slide {\n  margin-right: 0rem !important;\n}\n\n.slick-dots {\n  bottom: 12px !important;\n}\n\n.slick-card {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n}\n\n@keyframes glowing-border {\n  0% {\n    border-color: #1995d2;\n    box-shadow: 0 0 10px #1995d2;\n  }\n  50% {\n    border-color: #4bcffa;\n    box-shadow: 0 0 20px #4bcffa;\n  }\n  100% {\n    border-color: #1995d2;\n    box-shadow: 0 0 10px #1995d2;\n  }\n}\n\n.glowing-border {\n  border: 2px solid transparent;\n  animation: glowing-border 2s infinite;\n  border-radius: 8px; /* Match your modal's border-radius */\n  padding: 10px; /* Adjust if needed */\n}\n\n.article-content * {\n  font-size: inherit;\n}\n\n.truncate-container {\n  display: -webkit-box; /* Use webkit box model */\n  -webkit-box-orient: vertical; /* Set orientation to vertical */\n  -webkit-line-clamp: 2; /* Limit to 2 lines */\n  overflow: hidden; /* Hide overflow */\n  text-overflow: ellipsis; /* Add ellipsis when text overflows */\n  white-space: normal; /* Allow wrapping */\n}\n\n.p0-initiate {\n  background-color: transparent;\n  color: #ff4545;\n  border: 1.5px solid #ff4545; /* Red border */\n  border-radius: 16px; /* Rounded corners */\n  font-size: 10px;\n  font-weight: bold;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  height: fit-content;\n  padding: 5px;\n}\n\n.p0-initiate:hover {\n  box-shadow: 0 4px 8px rgba(255, 0, 0, 0.3); /* Red shadow on hover */\n  transform: translateY(-2px); /* Slight upward movement on hover */\n}\n\n.red_btn {\n  background-color: #fff;\n  border-radius: 8px;\n  color: #ff4c4c;\n  border: 1px solid #ff4c4c;\n  box-sizing: border-box;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  height: 40px;\n  line-height: 20px;\n  list-style: none;\n  outline: none;\n  padding: 10px 18px;\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  transition: color 200ms;\n  vertical-align: baseline;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  text-transform: uppercase;\n  letter-spacing: 1.5;\n  letter-spacing: 0.2px;\n}\n\n.red_btn:hover,\n.red_btn:focus {\n  color: #ff4c4c;\n  border: 1px solid #ff4c4c;\n}\n\n.slick-track {\n  transform: translate3d(-488px, 0px, 0px);\n}\n\n.Assessment_btn {\n  font-size: 12px;\n  padding: 5px 23px;\n  border-radius: 5px;\n  transition: all 0.15s ease;\n  color: #fff !important;\n  border: 1px solid none;\n  text-align: center;\n  color: #fff;\n  line-height: 24px;\n  cursor: pointer;\n}\n\n.recommend-article {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n/* In your CSS file or Tailwind custom styles */\n.article-content iframe {\n  width: 560px;\n  height: 315px;\n  margin: 0 auto;\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n.PhoneInputInput {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\nselect:not(.rdt_Pagination select) {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  padding: 0.625rem ;\n  border: 1px solid #ebeaec;\n  background-color: #f9fafb;\n  /* font-size: 12px; */\n\n  background-image: url(\"https://www.svgrepo.com/show/304510/arrow-bottom.svg\"); /* Right arrow icon */\n  background-position: right 10px center;\n  background-repeat: no-repeat;\n  background-size: 20px 20px;\n}\n\n.ps-submenu-expand-icon{\n  margin-bottom: 7px;\n}\n.profileSetting .PhoneInputInput {\n  background-color: #f9fafb !important;\n}\n\n@keyframes ribbonPop {\n  0% {\n    opacity: 0;\n    transform: translateY(-10px) rotate(45deg) scale(0.9);\n  }\n  50% {\n    opacity: 0.5;\n    transform: translateY(0px) rotate(45deg) scale(1.05);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px) rotate(45deg) scale(1);\n  }\n}\n\n.animate-ribbon {\n  animation: ribbonPop 0.6s ease-out;\n}\n\n.feature-title {\n  font-size: 24px;\n}\n\n.feature-subtitle {\n  font-size: 18px;\n}\n\n.card-title {\n  font-size: 18px;\n}\n\n.card-subtitle {\n  font-size: 14px;\n  font-weight: 400;\n  margin-top: 5px;\n}\n\n.card-icon-background{\n  background-color: #f3f4f6 ;\n}\n\n.card-icon {\n  color: #1995d2;\n  font-size: 18px;\n}\n\n.card-delete-icon{\n  color: #f75d65;\n  font-size: 18px;\n}\n\n.table-icon {\n  font-size: 19px;\n}\n\n.table-icon:hover {\n  color: #1995d2;\n}\n\n.table-delete-icon{\n  font-size: 19px;\n}\n\n.table-delete-icon:hover {\n  color: #f75d65;\n}\n.content-from-backend ul {\n  list-style: disc inside; /* Changed to 'inside' */\n  margin: 0;\n  padding: 0; /* You might still want a slight padding-left on the ul here for overall indentation */\n  margin-bottom: 0.5em;\n}\n.content-from-backend ol {\n  list-style-type: decimal; /* Ensures numerical markers (1, 2, 3...) */\n  margin: 0; /* Remove default margin */\n  padding-left: 1.2em;\n  margin-bottom: 0.5em; /* Space after the list */\n}\n/* In your CSS file (e.g., TableStylePanel.css or a global CSS file) */\n.hide-scrollbar {\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;     /* Firefox */\n}\n\n/* For Webkit browsers (Chrome, Safari) */\n.hide-scrollbar::-webkit-scrollbar {\n  display: none;             /* Hide scrollbar */\n}\n\n.content-from-backend li {\n  display: list-item; /* This ensures it behaves as a list item */\n  margin-bottom: 0.4em; /* Space between list items */\n  line-height: 1.5;\n  /* Importantly, remove any extra padding/margin that might be here */\n  padding: 0;\n  margin: 0;\n}\n\n/* Add a rule to remove default margin from paragraphs *inside* list items */\n.content-from-backend li p {\n  margin: 0; /* This is CRUCIAL to prevent the <p> from forcing a new line */\n  display: inline; /* Treat the paragraph as inline content within the list item */\n  /* Or if you need to keep block behavior but not force newline: */\n  /* display: inline-block; */\n}\n\n.page-break {\n  page-break-after: always;\n  break-after: page;\n}\n\n.chart-card, .chart-card * {\n  overflow: visible !important;\n}\n\n\n\n@media (max-width: 767px) {\n  .margin-mobile {\n    margin-top: 8rem; /* Apply 14rem margin-top on mobile screens */\n  }\n}\n\n@media (max-width: 767px) {\n  .margin-mobile-view {\n    margin-top: 20rem; /* Apply 14rem margin-top on mobile screens */\n  }\n}\n\n\n\n@keyframes rotateXIcon {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(180deg);\n  }\n}\n\n.rotate-x-icon {\n  animation: rotateXIcon 0.5s ease-out forwards;\n}\n\n/* Wavy scaling animation */\n    .wave-ring {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      border-radius: 9999px;\n      background-color: rgba(34, 87, 222, 0.3); \n      animation: ripple 1.8s ease-out infinite;\n      z-index: -1;\n    }\n\n    @keyframes ripple {\n      0% {\n        transform: scale(1);\n        opacity: 0.7;\n      }\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n.quill-custom-height .ql-editor {\n  height: 150px; \n  overflow-y: auto;\n} \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
